// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  ICertificationWebpageProcessDateGetDetailAttrs,
  ICertificationWebpageProcessDateUpdateAttrs,
} from 'interfaces/webpage/certification/registration/process-date/process-date-view.interface'

const useCertificationProcessDate = () => {
  // Hook
  const {
    certificationWebpageProcessDate: {
      certificationWebpageProcessDate_loading,
      certificationWebpageProcessDate_detail,
      certificationWebpageProcessDate_CLEAR_DETAIL,
      certificationWebpageProcessDate_fetchDetail: fetchDetail,
      certificationWebpageProcessDate_update: update,
    },
  } = useStores()

  /**
   * @description Get purpose of assessment detail
   *
   * @param {ICertificationWebpageProcessDateGetDetailAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpageProcessDate_fetchDetail = useCallback(
    (payload: ICertificationWebpageProcessDateGetDetailAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchDetail({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchDetail],
  )

  /**
   * @description Update purpose of assessment
   *
   * @param {ICertificationWebpageProcessDateUpdateAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpageProcessDate_update = useCallback(
    (payload: ICertificationWebpageProcessDateUpdateAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        update({
          params: { ...payload.params },
          body: { ...payload.body },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [update],
  )

  return {
    certificationWebpageProcessDate_loading,
    certificationWebpageProcessDate_detail,
    certificationWebpageProcessDate_CLEAR_DETAIL,
    certificationWebpageProcessDate_fetchDetail,
    certificationWebpageProcessDate_update,
  }
}

export { useCertificationProcessDate }
